import { Outlet } from 'react-router'
import { routes as LoadSchedulingAdminRoutes } from './loadSchedulingAdmin'

export const routes = [
  {
    key: 'admin',
    path: '/admin',
    main: <Outlet />,
    childRoutes: [...LoadSchedulingAdminRoutes],
  },
]
